import { Alert } from '@mui/material';

export default function AlertMessage({
  severity,
  message,
}) {
  return (
    <Alert severity={severity} variant="outlined" sx={{ py: 0.5, fontSize: '0.85rem' }}>
      {message}
    </Alert>
  );
}
